import { render, staticRenderFns } from "./CreateBirthDay.vue?vue&type=template&id=6a4d5b86"
import script from "./CreateBirthDay.vue?vue&type=script&lang=js"
export * from "./CreateBirthDay.vue?vue&type=script&lang=js"
import style0 from "./CreateBirthDay.vue?vue&type=style&index=0&id=6a4d5b86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../and-iot-pre-checkin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports